/*
 * @Description:
 * @Date: 2021-09-15 14:35:55
 */
// @ts-nocheck
import './public-path';
import { createApp } from 'vue';
import App from './App.vue';
// import store from './store'; // 需在router之前先引入，否则store中require.context会出问题：fn(path)可以获得，但里面的属性无法获取。
import { setupStore } from './store';
import router, { setupRouter } from './router';
import { setupGlobalComponents, setupDirectives } from '@/plugins';
import './assets/css/reset.css';
import 'xrk-components/lib/index.css';
import './styles/custom-style/form-dialog.scss';
import './styles/custom-style/table.scss';
import './styles/custom-style/common.scss';
import { register } from './qiankun';
import { getFirstLevelDomain } from '@/utils/url';

document.domain = getFirstLevelDomain();

register();

const app = createApp(App);

setupStore(app);

setupRouter(app);

setupGlobalComponents(app);
setupDirectives(app);

router.isReady().then(() => app.mount('#app'));

window.rootV3Instance = app;
